import { useEffect } from 'react';
import { filterWidgetEvent } from '@client/foundation/shared/utils/filter-widget-event';
import { useWidget } from '@client/widgets/widget.hook';
import { WidgetPayload } from '@client/widgets/widget.types';
import { useWindow } from '@client/window/window.hook';

export const useIndicatorTemplateEditorEvents = () => {
  const { openWidget$ } = useWidget();
  const { openWindow } = useWindow();

  useEffect(() => {
    const subscription = openWidget$()
      .pipe(
        filterWidgetEvent<WidgetPayload, 'IndicatorTemplateEditor'>(
          'IndicatorTemplateEditor'
        )
      )
      .subscribe((payload) => {
        openWindow({
          type: 'IndicatorTemplateEditor',
          sx: {
            maxWidth: 'lg',
            width: '90%'
          },
          componentProps: {
            templateId: payload.templateId,
            initialName: payload.initialName,
            initialIndicators: payload.initialIndicators,
            onSaved: payload.onSaved
          }
        });
      });

    return () => subscription.unsubscribe();
  }, [openWidget$, openWindow]);
};
